import React, { useContext, useState } from 'react'
import UserInfoDetailTab from './tabs/UserInfoDetailTab'
import UserAuditTab from './tabs/UserAuditTab'
import UserMaxRefundsTab from './tabs/UserMaxRefundsTab'
import UserGeofenceTab from './tabs/UserGeofenceTab'

import { UserInfoContext } from './context/UserInfoProvider'
import { UserConfigContext } from './context/UserConfigProvider'

import SuccessCreateUserModal from './component/modal/SuccessCreateUserModal'
import LoadingScreen from '../components/LoadingScreen'
import TabsMui from '../layout/TabsMui'
import TimedToastAlert from '../components/alerts/TimedToastAlert'

import { canViewUserRefundLimitsTab } from '../global_context/capabilities/userAppCapabilities'

const USER_CONFIG_TABS = [
  {
    label: 'Detalles',
    value: 'Detalles',
    icon: 'info'
  },
  {
    label: 'Máximo de devoluciones',
    value: 'Máximo de devoluciones',
    icon: 'replay',
    accessKey: 'refund_limits'
  },
  {
    label: 'Geocerca',
    value: 'Geocerca',
    icon: 'location_on'
  },
  {
    label: 'Historial',
    value: 'Historial',
    icon: 'schedule',
    accessKey: 'refund_limits'
  }
]

const TabsUserConfig = () => {
  const {
    isEditingUserInfoTab,
    userInfoData,
    isFetching,
    activeTab,
    handleTabClickDetails,
    failedCreationInfo,
    createUserParams
  } = useContext(UserInfoContext)

  const { isEditingUserConfigTab, handleTabClickConfig } = useContext(UserConfigContext)

  const [failedRefundLimitUpdate, setFailedRefundLimitUpdate] = useState(false)
  const [successRefundLimitUpdate, setSuccessRefundLimitUpdate] = useState(false)

  const tabs = USER_CONFIG_TABS.filter((tab) => !tab.accessKey || canViewUserRefundLimitsTab())

  const handleTabChange = (value) => {
    handleTabClickDetails(value)
    handleTabClickConfig(value)
  }

  const isEditing = isEditingUserInfoTab !== isEditingUserConfigTab

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      {failedRefundLimitUpdate && (
        <TimedToastAlert
          id="user-config-error-toast"
          variant="toast"
          severity="error"
          message={failedRefundLimitUpdate}
          onClose={() => setFailedRefundLimitUpdate(false)}
        />
      )}

      {successRefundLimitUpdate && (
        <TimedToastAlert
          id="user-config-success-toast"
          variant="toast"
          severity="success"
          message={successRefundLimitUpdate}
          onClose={() => setSuccessRefundLimitUpdate(false)}
        />
      )}

      {createUserParams && <SuccessCreateUserModal userInfo={createUserParams} />}

      {failedCreationInfo && (
        <div className="alert alert-danger">
          <strong>{failedCreationInfo}</strong>
        </div>
      )}

      <div className="main-show-header">
        {isEditing ? (
          <h2>
            Actualizar detalles del usuario:{' '}
            {userInfoData.route_db_ref + ' - ' + userInfoData.full_name}
          </h2>
        ) : (
          <h2>
            {userInfoData
              ? `Usuario: ${userInfoData.route_db_ref} - ${userInfoData.full_name}`
              : 'Usuario'}
          </h2>
        )}
      </div>

      <div className="index-table">
        <div className="show-area-tab">
          <TabsMui tabs={tabs} activeTab={activeTab} onChange={handleTabChange} scrollable />

          {activeTab === 'Detalles' && <UserInfoDetailTab />}
          {activeTab === 'Máximo de devoluciones' && (
            <UserMaxRefundsTab
              setFailedRefundLimitUpdate={setFailedRefundLimitUpdate}
              setSuccessRefundLimitUpdate={setSuccessRefundLimitUpdate}
            />
          )}
          {activeTab === 'Geocerca' && (
            <UserGeofenceTab
              setFailedGeofenceUpdate={setFailedRefundLimitUpdate}
              setSuccessGeofenceUpdate={setSuccessRefundLimitUpdate}
            />
          )}
          {activeTab === 'Historial' && <UserAuditTab />}
        </div>
      </div>
    </>
  )
}

export default TabsUserConfig
